/**
 * Backend Error Mapping
 */

import { errors } from "com";

const { SystemError, ValidationError, CredentialsError, DuplicityError, NotFoundError, OwnershipError, WorkerUnreachableError } = errors;

/**
 * Map of backend error names to Error classes
 */
export const ERROR_MAP: Record<string, new (message: string) => Error> = {
  ValidationError,
  CredentialsError,
  DuplicityError,
  NotFoundError,
  OwnershipError,
  SystemError,
  WorkerUnreachableError,
};

/**
 * Get error class from backend error name
 */
export function getErrorClass(errorName: string): (new (message: string) => Error) | undefined {
  return ERROR_MAP[errorName];
}

/**
 * Throw appropriate error based on backend response
 */
export function throwBackendError(errorName: string, message: string): never {
  const ErrorClass = getErrorClass(errorName);

  if (ErrorClass) {
    throw new ErrorClass(message || "Operation failed");
  }

  throw new SystemError(message || "An unexpected error occurred");
}
